import { Card, Col, Modal, Placeholder, Row, Table } from "react-bootstrap";

import { faArrowDown, faArrowUp, faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { callQuery, RISK_FEATURES_FOR_CSN } from "../../../amplify/api-gateway/query";
import FeatureImportanceChart, { FeatureData } from "./FeatureImportanceChart";
import { RiskConfig } from "./RiskTextSquare";

/**
 * Modal showing the featuers that contribute to the score calculation
 */
export const RiskFeatureModal = (props: {
    showModal: boolean,
    setShowModal: any,
    csn: string,
    config: RiskConfig,
    currentMetric: any,
    historyRisks: any,
    riskDetails: any,
    threshold?: number,
}) => {

    const [loading, setLoading] = useState(false);
    // const [features, setFeatures] = useState<FeatureData[]>([]);
    const actualThreshold = props.threshold === undefined ? 0.5 : props.threshold;
    const features = props.riskDetails && props.riskDetails["explanations"] ? props.riskDetails["explanations"][props.config.model] : [];

    // useEffect(() => {
    //     if (props.showModal) {
    //         setLoading(true);
    //         const promise = callQuery({
    //             operation: RISK_FEATURES_FOR_CSN,
    //             csn: props.csn,
    //             model: props.config.model,
    //         });

    //         Promise.all([promise]).then((values) => {
    //             const items: any[] = values[0];
    //             setFeatures(items);
    //             setLoading(false);
    //         });
    //     }
    // }, [props.showModal]);

    return (
        <Modal show={props.showModal} dialogClassName="modal-90w" onHide={() => props.setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{props.config.title} Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={3}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col className="metrics-title">{props.config.title}</Col>
                                </Row>
                                <Row>
                                    <Col xs="auto" className="metrics-value">{Math.round(props.currentMetric * 100) / 100}</Col>
                                    <Col className="metrics-relative">
                                        <Row>
                                            <Col className={props.currentMetric < actualThreshold ? "metrics-good" : "metrics-bad"}>
                                                <FontAwesomeIcon icon={props.currentMetric >= actualThreshold ? faArrowUp : faArrowDown} />{' '}
                                                {props.currentMetric >= actualThreshold ? "High Risk" : "Low Risk"}
                                            </Col>
                                        </Row>
                                        {/* <Row>
                                            {
                                                props.riskDetails && JSON.stringify(props.riskDetails["raw_data_mapping"])
                                            }
                                            {
                                                props.riskDetails && JSON.stringify(props.riskDetails["metadata"])
                                            }
                                        </Row> */}
                                    </Col>
                                </Row>
                                {
                                    props.historyRisks && props.historyRisks.map((metric: any) => (
                                        <Row>
                                            <Col xs="auto" className="metrics-history-value">{metric.prediction}</Col>
                                            <Col>
                                                <Row>
                                                    <Col className={`${metric.prediction < actualThreshold ? "metrics-good" : "metrics-bad"} metrics-history-description`}>
                                                        <FontAwesomeIcon icon={metric.prediction >= actualThreshold ? faArrowUp : faArrowDown} />{' '}
                                                        {metric.prediction >= actualThreshold ? "High Risk" : "Low Risk"} (at {metric.title})
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={9}>
                        {
                            loading ? (
                                <Row>
                                    <Col>
                                        <FontAwesomeIcon icon={faSpinner} spin />{' '}Loading...
                                    </Col>
                                </Row>
                            ) : (
                                <Row>
                                    <Col>
                                        <FeatureImportanceChart data={features} />
                                    </Col>
                                </Row>
                            )
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};
